import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  topNavigation: [],
  sidebar: {
    logo: "/icon.svg"
  },
  docs: {
    files: ["/docs/**/*.mdx"]
  },
  metadata: {
    favicon: "/icon.svg",
    title: "Formation CI/CD DevOps",
    description:
      "Formation complète sur l'intégration et le déploiement continus (CI/CD) avec une approche DevOps moderne. De l'installation de Gitea aux pratiques GitOps avancées.",
    generator: "Zudoku",
    applicationName: "Formation CI/CD DevOps",
    keywords: [
      "ci-cd",
      "devops",
      "gitea",
      "kubernetes",
      "docker",
      "gitops",
      "formation"
    ],
    publisher: "Formation DevOps",
  },
  navigation: [
    {
      type: "category",
      label: "Formation CI/CD DevOps",
      items: [
        "home",
        "prerequisites-setup",
        {
          type: "category",
          label: "📅 JOUR 1 - Fondamentaux CI/CD",
          collapsible: false,
          items: [
            "day1/index",
            "day1/theoretical-concepts",
            "day1/gitea-installation",
            "day1/first-workflows",
            "day1/practical-workshops"
          ]
        },
        {
          type: "category",
          label: "📅 JOUR 2 - CI Avancé + CD",
          collapsible: false,
          items: [
            "day2/index",
            "day2/advanced-workflows",
            "day2/docker-registry",
            "day2/kubernetes-essentials",
            "day2/practical-workshops"
          ]
        },
        {
          type: "category",
          label: "📅 JOUR 3 - GitOps + IaC",
          collapsible: false,
          items: [
            "day3/index",
            "day3/argo-cd",
            "day3/cdk8s",
            "day3/complete-pipeline",
            "day3/practical-workshops"
          ]
        },
        {
          type: "category",
          label: "🔧 Référence & Troubleshooting",
          items: [
            "reference-troubleshooting",
            "commands-reference",
            "common-issues"
          ]
        },
        {
          type: "category",
          label: "🚀 Ressources & Prochaines étapes",
          items: [
            "resources",
            "next-steps"
          ]
        },
        "faq"
      ]
    }
  ],
  redirects: [
    { from: "/", to: "/home" }
  ],
};

export default config;
